import fetchApi from "@api/fetchApi";
import { sensor } from "@tsTypes/sensorType";

export async function _requestGetMesures (currentSensor: sensor, reqDate1: string, reqDate2: string) {
    
    //on requête les mesures
    const res = await fetchApi.post(`/sensor/get-mesures`, {idSensor: currentSensor.id_compteur, startDate: reqDate1, endDate: reqDate2, type: currentSensor.type_energie})
    
    return res?.data
}